import { Layers, SlidersHorizontal } from "lucide-react";
import type React from "react";
import { useState } from "react";
import GraphControlsPanel from "@/features/graph/components/controls/GraphControlsPanel";
import type { LeftPanelTabsProps } from "@/features/notebook/types/notebook";
import SourcesPanel from "@/features/sources/components/SourcesPanel";

type LeftTab = "sources" | "controls";

const LeftPanelTabs: React.FC<LeftPanelTabsProps> = ({
	selectedSources,
	onSourceToggle,
	onSelectAll,
	onGraphGenerated,
	workspaceId,
	graphStatistics,
	graphId,
	graphNodes,
	graphEdges,
	selectedNodeId,
	selectedEdgeId,
	onFilter,
	onResetFilter,
}) => {
	const [activeTab, setActiveTab] = useState<LeftTab>("sources");

	return (
		<div className="left-panel">
			<div className="left-panel-tabs" role="tablist">
				<button
					type="button"
					role="tab"
					aria-selected={activeTab === "sources"}
					onClick={() => setActiveTab("sources")}
					className={`left-panel-tab ${activeTab === "sources" ? "left-panel-tab--selected" : "left-panel-tab--unselected"}`}
				>
					<Layers className="w-4 h-4 shrink-0" />
					<span>Sources</span>
				</button>
				<button
					type="button"
					role="tab"
					aria-selected={activeTab === "controls"}
					onClick={() => setActiveTab("controls")}
					className={`left-panel-tab ${activeTab === "controls" ? "left-panel-tab--selected" : "left-panel-tab--unselected"}`}
				>
					<SlidersHorizontal className="w-4 h-4 shrink-0" />
					<span>Controls</span>
				</button>
			</div>
			<div className="left-panel-content">
				{activeTab === "sources" && (
					<SourcesPanel
						selectedSources={selectedSources}
						onSourceToggle={onSourceToggle}
						onSelectAll={onSelectAll}
						onGraphGenerated={onGraphGenerated}
						workspaceId={workspaceId}
						embeddedInTabs
					/>
				)}
				{activeTab === "controls" &&
					(graphStatistics ? (
						<GraphControlsPanel
							statistics={graphStatistics}
							nodes={graphNodes}
							edges={graphEdges}
							selectedNodeId={selectedNodeId}
							selectedEdgeId={selectedEdgeId}
							graphId={graphId}
							onFilter={onFilter}
							onResetFilter={onResetFilter}
							embedded
						/>
					) : (
						<div className="left-panel-empty">Load or select a graph to see controls.</div>
					))}
			</div>
		</div>
	);
};

export default LeftPanelTabs;
